import { Link } from "react-router-dom";
import { Navbar, NavbarBrand } from "reactstrap";
import HeaderSurfaceSwitcher from "./HeaderSurfaceSwitcher";
// import StudentPrivacyToggle from "./StudentPrivacyToggle";

const Header = () => {
  return (
    <>
      <Navbar
        className="header-banner"
        expand="md"
      >
        <div className="header-banner-inner">
          <HeaderSurfaceSwitcher />
          <div className="header-banner-leading">
            <NavbarBrand
              tag={Link}
              to="/"
              className="header-banner-brand"
              aria-label="Teach League home"
            >
              <span className="header-logo-shell" aria-hidden="true">
                <img
                  src={require("../app/assets/img/TLLogo.svg").default}
                  alt="Teach League Logo"
                  className="teach-league-logo-3d"
                />
              </span>
              <span className="header-brand-copy">
                <span className="header-brand-title" aria-label="Teach League">
                  Teach League
                </span>
              </span>
            </NavbarBrand>
          </div>
        </div>
      </Navbar>
    </>
  );
};

export default Header;
